import React from 'react';
import MyNavbar from '../../../../components/user/general/mynavbar/MyNavbar';
import MechanicDetail from '../../../../components/user/maintain/mechanicdetail/MechanicDetail';
import Footer from '../../../../components/user/general/footer/Footer';

const MechanicSingleDetailPage = () =>{
    return (
        <>
        <MyNavbar />
        <MechanicDetail />
        <Footer />
        </>
    )
}
export default MechanicSingleDetailPage;